<template>
  <div class="pt-main-content">
    <h1 class="pt-main-content__title text-2xl lg:text-4xl font-bold mb-6">{{ title }}</h1>
    <slot name="labels"></slot>
    <span
      class="pt-main-content__summary font-sans tracking-normal text-gray text-base font-semibold leading-5 lg:font-normal lg:text-2xl lg:leading-7 mt-6"
      v-text="summary"
    />
  </div>
</template>

<script>
export default {
  name: 'MainContent',
  props: {
    title: {
      type: String,
      default: ''
    },
    summary: {
      type: String,
      default: ''
    }
  }
};
</script>
